import React from 'react';
import { CallbackComponent } from 'redux-oidc';
import { object } from 'prop-types';


import { userManagerFactory } from '../../../services/oidc/utils/userManager';



const CallbackOidcPage = props => (
  <React.Fragment>
    <CallbackComponent
      userManager={userManagerFactory()}
      successCallback={(data) => {
        localStorage.setItem('isInitial', true);
        props.history.push('/');
      }}
      errorCallback={() => {
        props.history.push('/login');
      }}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  </React.Fragment>
);
CallbackOidcPage.propTypes = {
  history: object,
};

export default CallbackOidcPage;



// WEBPACK FOOTER //
// ./src/features/login/pages/CallbackOidcPage.jsx